import ReactDOM from 'react-dom'

// Doit etre importe avant tout appel fetch() de l'application (voir
// Auth/httpInterceptor.ts) : gere la reconnexion SSO sur un 403 du backend.
import './Auth/httpInterceptor.ts'

import App from './App.tsx'
import { GoogleOAuthProvider } from '@react-oauth/google';
import Login from './Login.tsx';
import ThemeApplication from './Theme/ThemeApplication.tsx';


// Define your Google Client ID obtained from Google Developer Console
const clientId = "10377605108-1t28l4g2685o8eofppe8pc0lek6f5mtl.apps.googleusercontent.com";

// Create a root element for rendering the app
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the app wrapped in GoogleOAuthProvider for Google OAuth functionality
root.render(
  <GoogleOAuthProvider clientId={clientId}>
    <ThemeApplication>
      <Login />
    </ThemeApplication>
  </GoogleOAuthProvider>
);